import gql from 'graphql-tag';

export const GET_VERSION = gql`
  query GET_VERSION {
    version
  }
`;
